import EntryMaterialTemplate from "../templates/EntryMaterialTemplate"; // テンプレートコンポーネントのインポート
import { dataForNo1, dataForNo2, titles, NO_1, NO_2 } from '../types/guestMaterial'; // データとタイトルのインポート
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'; // React Routerのフックをインポート
import { useEffect } from 'react'; // ReactのuseEffectフックをインポート
import EMObject from "../molecules/EMObject";
import GuestTestPage from './GuestTestPage'; // GuestTestPageをインポート

const EntryMaterialPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate(); // ナビゲート用フック
    const no = searchParams.get("no"); // URLからnoの値を取得
    const guestPageNo = searchParams.get("guestPageNo") || "1"; // URLからguestPageNoの値を取得し、デフォルトは"1"に設定

    useEffect(() => {
        if (no !== guestPageNo && no !== NO_1 && no !== NO_2) {
            navigate("/login"); // noが一致しない場合にログインページにリダイレクト
        }
    }, [no, navigate, guestPageNo]);

    // リダイレクトが失敗した場合
    if (no !== NO_1 && no !== NO_2 && no !== guestPageNo) {
        return null; // 'no'がNO_1またはNO_2でない場合、何も表示しない
    }

    if (no === NO_2) {
        return <GuestTestPage />; // 'no'がNO_2の場合、UserProblemsPageを表示
    }

    const demoTitle = no && (no === NO_1 || no === NO_2) ? titles[no] : ""; // 'no'に基づいてタイトルを選択
    const selectedData = no === NO_1 ? dataForNo1 : dataForNo2; // 'no'に基づいてデータを選択

    // selectedDataの各項目に対して、objIdが存在する場合はEMObjectを追加
    const dataWithObjects = selectedData.map(item => ({
        ...item, // 既存のプロパティを保持
        obj: item.objId ? <EMObject oId={item.objId} /> : null // objIdに基づいてEMObjectを設定
    }));

    return (
        <EntryMaterialTemplate title={demoTitle} data={dataWithObjects} no={no} /> // dataWithObjectsを渡す
    );
};

export default EntryMaterialPage;